import script from "./HrActionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HrActionBar.vue?vue&type=script&setup=true&lang=js"

import "./HrActionBar.vue?vue&type=style&index=0&id=3b2c5858&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2c5858"]])

export default __exports__